import React from 'react'
import { Link } from 'react-router-dom'
import styled, { css } from 'styled-components'
import Flex from '@blocks/Flex'
import Info from '@blocks/Info'
import { ReactComponent as PlaceIcon } from '@icons/place.svg'
import { ReactComponent as CalendarIcon } from '@icons/calendar.svg'
import { ReactComponent as OrganizationIcon } from '@icons/organization.svg'
import { colors } from '@styles/vars'
import { modifier, desktop, tablet } from '@styles/mixins'
import Button from '@blocks/Button'
import Grid from '@blocks/Grid'
import { isOdd, route } from '@helpers'
import { Container } from '@styles/helpers'
import _ from 'lodash'

export default function CurrentSalon({ data, idx }: ArchiveComponentProps<Resources.CurrentSalon>) {
    const reversed = isOdd(idx || 0)
    const { id, name, country, closing_date, patronages, background_url, slug } = data
    const date = (new Date(closing_date)).toLocaleDateString("en-US", { month: 'long', day: 'numeric' })
    const organizations = _.uniq(patronages.map(patronage => patronage.organization?.name)).join(', ')
    return (
        <Wrapper reversed={reversed}>
            <Link to={route("general:salon", slug)}><Image src={background_url} /></Link>
            <Content>
                <Grid>
                    <Grid gap="20px">
                        <Link to={route("general:salon", slug)}><h2 className="h1">{name}</h2></Link>
                        <Flex flexWrap="wrap" gap="10px">
                            <Info label={country} icon={<PlaceIcon />} />
                            <Info label={date} icon={<CalendarIcon />} />
                            {organizations && <Info label={organizations} icon={<OrganizationIcon />} />}
                        </Flex>
                    </Grid>
                    <Flex gap="10px">
                        <Grid gap="10px" width="auto">
                            <Button width="fixed" to={route("customer:salon", id)}>Participate</Button>
                            <RulesAgreement>By participating, you acknowledge you've agreed to <Link to={route("general:salon:conditions", slug)}>conditions</Link></RulesAgreement>
                        </Grid>
                        <Button type="secondary" width="auto" to={route("general:salon:conditions", slug)}>Conditions</Button>
                    </Flex>
                </Grid>
            </Content>
        </Wrapper>
    )
}

// STYLES
const Content = styled(Container)`
    margin: 30px 0 60px;

    h2 {
        line-height: 100%;
        margin-bottom: 0;
    }

    a {
        text-decoration: none;
    }

    ${desktop(css`
        margin: 0;
        padding: 135px;
        display: flex;
        justify-content: center;
        align-items: center;
    `)}
`

const Image = styled.div<{ src: string }>`
    height: 320px;
    width: 100%;
    background: ${props => props.src ? "url(" + props.src + ") center center no-repeat" : colors.greyBackground};
    background-size: cover;

    ${desktop(css`
        min-height: 100vh;
        height: 100%;
    `)}
`

const Wrapper = styled.div<{ reversed: boolean }>`
    ${desktop(css`
        display: grid;
        grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
        align-items: shrink;

        ${modifier("reversed", css`
            ${Content} {
                grid-column-start: 1;
                grid-row-start: 1;
            }
        `)}
    `)}
`

const RulesAgreement = styled.small`
    text-align: center;
    color: ${colors.darkGrey};
    a {
        text-decoration: underline;
    }
    ${tablet(css`
        max-width: 220px;
        margin: 0 auto;
    `)}
`